	<template>
	<v-container fluid align-start fill-height>
		<div v-if="loading" style="width: 100%; height: 400px;">
			<v-row class="fill-height" align="center" justify="center">
				<v-col class="text-center">
					<v-progress-circular
						:size="50"
						:width="5"
						color="rgba(0,0,0,0.2)"
						class="mb-3"
						indeterminate
					></v-progress-circular>
					<p class="mb-0">Cargando Programación del Proyecto</p>
				</v-col>
			</v-row>
		</div>
		<div v-else style="width: 100%;">
			<v-row class="pb-4 mt-0 px-2" style="max-width: 1200px;">
				<v-col cols="5" class="py-0" style="max-width: 450px;">
					<div class="mb-3 d-flex justify-space-between align-center">
						<p class="mb-0 caption font-weight-bold">Proyecto</p>
					</div>
					<div v-if="selectedProject">
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Zona Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.info?.zone?.name}}</b></div>
							<div class="action-container">
								<v-menu v-model="zoneMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
									<template v-slot:activator="{ on, attrs }">
										<div class="action-container">
											<v-btn
												icon
												color="warning"
												x-small
												v-bind="attrs"
												v-on="on"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
											</v-btn>
										</div>
									</template>
									<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
										<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
											<p class="caption mb-0 font-weight-bold white--text">Cambiar Zona Proyecto</p>
										</v-list-item>
										<v-list-item-group color="#524D4D">
											<v-list-item
												v-for="(zone, index) in zones"
												:key="index"
												dense
												@click="changeIptZone(zone.id)"
											>
												<v-list-item-title dense>
													{{ zone.name }}
												</v-list-item-title>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-menu>
							</div>
						</div>
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Tipo Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.info?.project_type?.name}}</b></div>
							<div class="action-container">
								<v-btn
									depressed
									color="warning"
									x-small
									icon
									class="my-0 mr-1"
									@click="toProjectTypes"
								>
									<v-icon small>mdi-eye</v-icon>
								</v-btn>
								<v-menu v-model="projectTypeMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											color="warning"
											x-small
											v-bind="attrs"
											v-on="on"
										>
											<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
										</v-btn>
									</template>
									<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
										<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
											<p class="caption mb-0 font-weight-bold white--text">Cambiar Tipo Proyecto</p>
										</v-list-item>
										<v-list-item-group color="#524D4D">
											<v-list-item
												v-for="project_type in companyProjectTypes"
												:key="'pt_'+project_type.id"
												dense
												@click="changeProjectType(project_type.id)"
											>
												<v-list-item-title dense>
													{{ project_type.name }}
												</v-list-item-title>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-menu>
							</div>
						</div>
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Cliente</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.client.profile.name}} {{selectedProject.client.profile.lastname}} {{selectedProject.client.profile.second_lastname}}</b></div>
							<div class="action-container">
								<!-- <v-btn
									depressed
									color="warning"
									x-small
									icon
									@click.stop="goToPreProject"
								>
									<v-icon small>mdi-eye-outline</v-icon>
								</v-btn> -->
							</div>
						</div>
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Seguimiento</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.associations?.associations?.length > 0 ? 'Asociaciones del Proyecto':'Proyecto Sin Asociaciones'}}</b></div>
							<div class="action-container">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											depressed
											color="warning"
											x-small
											icon
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small class="mb-1">mdi-eye-outline</v-icon>
										</v-btn>
									</template>
									<v-list dense class="py-0">
										<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
											<p class="caption mb-0 font-weight-bold white--text">Asociaciones</p>
										</v-list-item>
										<v-list-item-group color="#524D4D">
											<v-list-item
												v-for="(association, index) in projectLineAssociations(selectedProject)"
												:key="'ass-'+index"
												dense
												@click="handleGoTo(association)"
												style="min-width: 200px"
											>
												<v-list-item-title dense>
													<div class="d-flex justify-space-between align-center item-background-hover">
														<div class="d-flex justify-space-between caption" style="width: 100%">
															<div style="width: 90px">{{ association.type_name }}</div>
															<span>:</span>
															<b class="text-end" style="flex: 1;">#{{association.morphable_id}}</b>
														</div>
													</div>
												</v-list-item-title>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-menu>
							</div>
						</div>
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.info?.address?.address}}</b></div>
							<div class="action-container">
							</div>
						</div>
						<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Municipio</div><span>:</span> <b class="text-end" style="flex: 1;">{{selectedProject.info?.address?.district?.name}}</b></div>
							<div class="action-container">
							</div>
						</div>
					</div>
				</v-col>
				<v-col cols="3" class="py-0">
					<div class="mb-3">
						<p class="mb-0 caption font-weight-bold">Etapas Proyectos (Empresa)</p>
						<p class="mb-0 caption">Selecciona las etapas que aplican para este proyecto</p>
					</div>
					<div class="d-flex flex-column fill-height">
						<div v-for="category in projectTypeCompanyPlanningCategories"
								:key="'st.'+category.id">
							<v-btn
								depressed
								small
								:color="projectCompanyPlanningCategoriesId.includes(category.id) ? '#FF120B':'grey'"
								:dark="projectCompanyPlanningCategoriesId.includes(category.id)"
								:outlined="!projectCompanyPlanningCategoriesId.includes(category.id)"
								class="mb-1"
								block
								@click="setCategoryToProject(category)"
							>
								<p class="mb-0 ml-1 caption text-left w-100">{{ category.name }}</p>
							</v-btn>
						</div>
					</div>
				</v-col>
				<v-col cols="4" class="py-0">
					<div class="mb-3 d-flex justify-space-between align-center" >
						<p class="mb-0 caption font-weight-bold">Etapas Adicionales</p>
						<v-btn
							depressed
							color="#959595"
							x-small
							outlined
							class="my-0"
							@click="startNewAdditionalStage"
						>
							<!-- :disabled="!projectPlanningCategories || projectPlanningCategories.length <= 1" -->
							<v-icon small>mdi-plus</v-icon>
							<p class="mb-0 ml-1 caption">Nueva</p>
						</v-btn>
					</div>

					<div style="position: relative;" :class="{'custom-blocked-additional-stages': allProjectPlanningStages.length == 0}">
						<div v-if="allProjectPlanningStages.length == 0"
							class="pa-6 custom-blocked-additional-stages d-flex align-center justify-center">
							<div class="pa-3" style="background-color: rgba(255,255,255,0.8);border: 1px solid #cecece;border-radius: 10px;">
								<p class="mb-1 font-weight-bold">Etapas del proyecto</p>
								<p class="mb-0">Primero debes seleccionar y/o configurar al menos una etapa para el proyecto</p>
							</div>
						</div>
						<v-list dense class="py-0 transparent" style="max-height: 200px; overflow-y: scroll;"
							:disabled="!selectedProject && loadingAdditionalStages">
							<v-list-item-group>
								<v-list-item
									v-for="(stage, index) in additionalStages"
									:key="index"
									dense
									class="px-0 py-0"
									:value="stage"
									@click="toggleAdditionalStage(stage, !hasAdditionalStage(stage))"
								>
									<v-list-item-title dense>
										<div class="d-flex align-center">
											<div class="d-flex justify-space-between align-center flex-grow-1">
												<div class="d-flex align-center">
													<v-btn
														depressed
														color="warning"
														x-small
														icon
														class="mr-2"
														@click.stop="startEditAdditionalStage(stage)"
													>
														<v-icon small>mdi-note-edit-outline</v-icon>
													</v-btn>
													<p class="caption mb-0 mr-2 font-weight-bold" style="max-width: 250px;text-wrap: wrap;">{{ stage.name }}</p>
													<v-tooltip bottom v-if="stage.description">
														<template v-slot:activator="{ on, attrs }">
															<v-icon
																v-bind="attrs"
																v-on="on"
																x-small>mdi-information</v-icon>
														</template>
														<span>{{ stage.description }}</span>
													</v-tooltip>
												</div>
											</div>
											<v-switch
												class="mt-0"
												color="#FF120B"
												dense
												hide-details
												:input-value="hasAdditionalStage(stage)"
												readonly
												:disabled="!selectedProject"
											></v-switch>
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
				</v-col>
			</v-row>
			<v-row class="py-2 my-1 px-2">
				<v-col cols="12">
					<v-divider class="mt-2 mb-4"></v-divider>
					<div class="mb-0">
						<p class="mb-1 caption font-weight-bold mr-4">Configuración Etapas</p>
						<p class="mb-0 caption">Considera que sólo las etapas que marques con <b>"Requiere Pago"</b> serán consideradas para la programación de pagos de la Tabla de Costos</p>
						<!-- <v-btn
							depressed
							color="green"
							small
							outlined
							class="my-0"
							v-if="!projectHasPlanning"
							:disabled="this.projectPlanning && this.projectPlanning.planning_categories.length == 0"
							@click="confirmPlanning"
						>
							<v-icon small>mdi-check-circle-outline</v-icon>
							<p class="mb-0 ml-1 caption">Confirmar Configuración</p>
						</v-btn> -->
					</div>
				</v-col>
				<v-col cols="12" class="py-0">
					<div v-if="projectPlanning" class="mt-3">
						<div v-for="(planning, index) in projectPlanningCategories" :key="index">
							<div class="ma-2 mb-0 mt-3">
								<p class="font-weight-bold mb-0">{{ planning.name }}</p>
							</div>
							<div class="d-flex justify-start align-center fill-height">
								<draggable
									class="d-flex flex-wrap align-center"
									v-model="planning.stages"
									handle=".handle_drag"
									@end="(ev) => startEndDragEventStages(ev, planning)"
									filter=".exclude"
									easing="cubic-bezier(1, 0, 0, 1)"
									animation="200"
									ghostClass="ghost-element-drag"
									style="cursor: move;"
									:move="onMoveDragEvent">
									<div
										class="my-2"
										v-for="(stage, index) in planning.stages"
										:key="index">
										<v-card
											class="my-0 mx-2"
											max-height="160px"
											max-width="250px"
											v-if="editStage && editCategoryStage.id == stage.id">
											<v-card-text class="fill-height d-flex flex-column align-center justify-center">
												<div class="d-flex flex-column justify-space-between align-center">
													<v-text-field
														label="Nombre Etapa"
														v-model="editCategoryStage.name"
														outlined
														required
														dense
														hide-details
														:rules="requiredRule"
													class="custom-height-search custom-height-calendar w-100"
													></v-text-field>
													<v-text-field
														label="Detalle (Opcional)"
														v-model="editCategoryStage.description"
														outlined
														required
														dense
														class="custom-height-search custom-height-calendar mt-1"
													></v-text-field>
													<div class="d-flex align-center mt-1" style="width: 100%">
														<v-checkbox class="my-0 py-0" v-model="editCategoryStage.needs_payment" color="#959595" hide-details dense></v-checkbox>
														<p class="mb-0 caption">Requiere Pago</p>
													</div>
													<div class="mt-2 d-flex" style="width: 100%">
														<v-btn
															depressed
															color="#FF120B"
															small
															dark
															class="mr-1 d-flex flex-grow-1"
															:loading="loadingCreateCategory"
															@click="updateStage()"
														>
															<v-icon small>mdi-check</v-icon>
														</v-btn>
														<v-btn
															depressed
															color="#959595"
															small
															dark
															:loading="loadingCreateCategory"
															@click="cancelEditStage()"
														>
															<v-icon small>mdi-close</v-icon>
														</v-btn>
													</div>
												</div>
											</v-card-text>
										</v-card>
										<v-card
											v-else
											class="my-0 mx-2 pa-0 square-card handle_drag"
											height="110px"
											width="160px">
											<v-card-text class="pa-3 fill-height d-flex flex-column align-start">
												<div class="flex-grow-1" style="width:100%">
													<p class="font-weight-bold caption mb-1 text-center" style="line-height: 13px;">{{stage.name}}</p>
													<p class="mb-0 text-center" style="font-size: 10px;line-height: 10px;">{{stage.description}}</p>
												</div>
												<div class="d-flex justify-space-between align-center" style="width: 100%">
													<div class="d-flex align-center">
														<v-btn
															depressed
															color="warning"
															x-small
															icon
															@click.stop="startEditStage(stage)"
														>
															<v-icon small>mdi-note-edit-outline</v-icon>
														</v-btn>
														<v-btn
															depressed
															color="#FF120B"
															x-small
															icon
															@click.stop="deleteStage(stage.id)"
														>
															<v-icon small>mdi-delete-outline</v-icon>
														</v-btn>
													</div>
													<v-chip
														:color="stage.needs_payment ? '#FF120B':'#959595'"
														label
														outlined
														x-small
													>
														<b>{{stage.needs_payment ? 'Requiere Pago':'Sin Pago'}}</b>
													</v-chip>
												</div>
											</v-card-text>
										</v-card>
									</div>
									<v-card
										class="my-2 mx-2"
										max-height="160px"
										max-width="250px"
										v-if="newCategoryStageShow && planning.id == newCategoryStage.project_planning_cat_id">
										<v-card-text class="fill-height d-flex flex-column align-center justify-center">
											<div v-if="newCategoryStageShow" class="d-flex flex-column justify-space-between align-center">
												<v-text-field
													label="Nombre Etapa"
													v-model="newCategoryStage.name"
													outlined
													required
													dense
													hide-details
													class="custom-height-search custom-height-calendar w-100"
												></v-text-field>
												<v-text-field
													label="Detalle (Opcional)"
													v-model="newCategoryStage.description"
													outlined
													required
													dense
													class="custom-height-search custom-height-calendar mt-3"
												></v-text-field>
												<div class="d-flex align-center mt-1" style="width: 100%">
													<v-checkbox class="my-0 py-0" v-model="newCategoryStage.needs_payment" color="#959595" hide-details dense></v-checkbox>
													<p class="mb-0 caption">Requiere Pago</p>
												</div>
												<div class="mt-2 d-flex" style="width: 100%">
													<v-btn
														depressed
														color="#FF120B"
														small
														dark
														class="mr-1 d-flex flex-grow-1"
														:loading="loadingCreateCategory"
														@click="confirmCategoryStage()"
													>
														<v-icon small>mdi-check</v-icon>
													</v-btn>
													<v-btn
														depressed
														color="#959595"
														small
														dark
														:loading="loadingCreateCategory"
														@click="closeNewCategoryStage()"
													>
														<v-icon small>mdi-close</v-icon>
													</v-btn>
												</div>
											</div>
										</v-card-text>
									</v-card>
									<v-card
										class="my-2 mx-2 square-card exclude"
										height="90px"
										width="90px"
										style="cursor: pointer;"
										v-else
										@click="startNewCategoryStage(planning)">
										<v-card-text class="fill-height d-flex flex-column align-center justify-center">
											<v-icon large>mdi-plus</v-icon>
										</v-card-text>
									</v-card>
								</draggable>
							</div>
						</div>
					</div>
				</v-col>
			</v-row>
		</div>
		<NewProjectCategory v-if="$store.state.projects.categoryModal" :reload="getCategories"/>
		<CopyCompanyStage
			v-if="$store.state.projects.toCopyCompanyPlanningCategoryId"
			:reload="toNewCopiedStage"/>
		<NewProjectAdditionalStage v-if="$store.state.projects.additionalStageModal" :reload="getAdditionalStages"/>
		<NoReceptionInTableModal
			v-if="selectedProject && showNoreceptionModal"
			:selectedProject="selectedProject"
			:closeModal="closeNoReceptionInTableModal"/>
	</v-container>
</template>

<script>
import draggable from 'vuedraggable'
import _debounce from 'lodash/debounce'
import _throttle from 'lodash/throttle'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import NewProjectCategory from '@/components/Modals/Projects/NewProjectCategory'
import CopyCompanyStage from '@/components/Modals/Projects/CopyCompanyStage'
import NewProjectAdditionalStage from '@/components/Modals/Projects/NewProjectAdditionalStage'
import NoReceptionInTableModal from '@/components/Modals/Projects/NoReceptionInTableModal'
import {updateProjectInfo, setProjectPlanningCategoryPrj, updateProjectPlanningStagePrj, updateProjectPlanningStageOrderPrj, createProjectPlanningStagePrj, getProjectPlanningPrj, createProjectPlanningCategory, deleteProjectPlanningCategory, removeProjectPlanningStage, deleteZoneIpt, getAllProjectPlanningStages} from '@/helpers/api/projects'

export default {
	name: 'ProjectPlanningConfigComponent',
	components: {draggable, NewProjectCategory, CopyCompanyStage, NewProjectAdditionalStage, NoReceptionInTableModal},
  data() {
    return {
			loading: true,
			showNoreceptionModal: false,
			zoneMenu: false,
			projectTypeMenu: false,
			hasSeremi: false,
			hasCMN: false,
			additionalStages: [],
			loadingAdditionalStages: false,
			projectPlanning: null,
			projectCost: null,
			selectedZone: 1,
			projectType: 1,
			selectedCategory: [],
			selectedProject: null,
			newCategoryShow: false,
			loadingCategoryOrder: false,
			loadingStateOrder: false,
			loadingCreateCategory: false,
			newCategory: {
				name: null,
				description: null,
				order: 1
			},
			newCategoryStageShow: false,
			loadingCreateCategoryStage: false,
			newCategoryStage: {
				name: null,
				description: null,
				order: 1,
				needs_payment: false,
				project_planning_cat_id: null
			},
			editStage: false,
			editCategoryStage: null,
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			stageCreationPromises: new Map(), // Guardar las promesas de creación por código de stage
    };
  },
  computed: {
		filteredCategories() {
			if (this.projectCostIsArchitectural) {
				return this.categories;
			}

			if (this.projectCostWithReception) {
				return this.categories.filter(
					c => c.with_reception && !c.with_permission
				);
			}

			return this.categories.filter(
				c => !c.with_permission && !c.with_reception
			);
		},
		companyProjectTypes(){
			return this.$store.state.companies.companiesProjectTypes
		},
		companyPlanningStages(){
			return this.$store.state.companies.companyPlanningStages
		},
		projectTypeCompanyPlanningCategories(){
			if(!this.selectedProject) return null
			const selectedProjectType = this.$store.state.companies.companiesProjectTypes.find(project_type => {
				if (project_type.id == this.selectedProject.info?.project_type_id) return true;
				if (project_type.sub_types?.some(sub => sub.id == this.selectedProject.info?.project_type_id)) {
					return true;
				}
				return false;
			});
			if(selectedProjectType){
				return this.companyPlanningStages.filter((stage) => {
					return selectedProjectType.includes.includes(stage.id)
				})
			}
			return null
		},
		projectHasPlanning(){
			return this.projectPlanning && this.projectPlanning.planning_categories.length > 0
		},
		projectCompanyPlanningCategoriesId(){
			if(this.projectPlanning && this.projectPlanning.planning_categories){
				return this.projectPlanning.planning_categories.map(category => category.company_stage_id)
			}
			return []
		},
		projectCostIsArchitectural(){
			return this.projectCost?.cost_project?.is_architectural
		},
		projectCostWithReception(){
			return this.projectCost?.reception
		},
		// selectedProject(){
		// 	if(this.companyProjects && this.$store.state.projects.projectPlanningConfigModal){
		// 		const project = this.companyProjects.find((project) => {
		// 			return project.id == this.$store.state.projects.projectPlanningConfigModal?.project?.id
		// 		})
		// 		if(project) return project
		// 	}
		// 	return this.$store.state.projects.projectPlanningConfigModal?.project || null
		// },
		companyProjects(){
			return this.$store.state.projects.companyProjects
		},
		zones() {
			return this.$store.state.projects.zoneIpt
		},
		projectPlanningCategories(){
			if(this.projectPlanning){
				return this.projectPlanning.planning_categories
			}
			return []
		},
		allProjectPlanningStages(){
			const allStages = []
			if(this.projectPlanningCategories && this.projectPlanningCategories.length > 0){
				this.projectPlanningCategories.forEach(category => {
					if(category.stages && category.stages.length > 0){
						allStages.push(...category.stages)
					}
				})
			}
			console.log('allStages', allStages)
			return allStages
		},
		categories: {
			get() {
				return this.$store.state.projects.projectPlanningCategories
			},
			set(value) {
				this.$store.commit('projects/setProjectPlanningCategories', value);
			},
		},
		selectedCategoryStages: {
			get() {
				if(this.selectedCategoriesInfo && this.categories && this.categories.length > 0){
					const found = this.selectedCategoriesInfo.find(category => category.id === this.selectedCategory)
					return found ? found.stages:[]
				}
				return null
			},
			set(value) {
				const index = this.categories.findIndex(category => category.id === this.selectedCategory)
				if(index != -1){
					this.categories[index].stages = value
				}
			},
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		selectedCategoriesInfo(){
			if(!this.categories){ return null }
			return this.categories.filter(cat => this.selectedCategory.includes(cat.id))
		},
		newCreatedElement(){
			return this.$store.state.general.newCreatedElement
		}
  },
	watch: {
		newCreatedElement(newValue){
			if(newValue && newValue.type == 'project'){
				this.selectedProject = newValue.value
				this.$store.commit('general/setNewCreatedElement', null)
			}
		},
		zones(newValue){
			if(newValue && newValue.length > 0){
				this.selectedZone = newValue[0].id
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('companies/getCompanyProjectTypes')
			}
		},
		selectedZone(newValue, oldValue){
			if(newValue != oldValue || !newValue){
				this.selectedCategory = null
			}
			this.getCategories()
		},
		projectType(newValue, oldValue){
			if(newValue != oldValue || !newValue){
				this.selectedCategory = null
			}
			this.getCategories()
		},
		selectedProject(newValue, oldValue){
			if(newValue){
				if(oldValue?.id != newValue.id){
					this.debouncedGetProjectPlanning(true)
					this.getCategories()
				}
			}
			else{
				this.hasSeremi = false
				this.hasCMN = false
				this.projectPlanning = null
				this.selectedCategory = []
				this.newCategoryShow = false
				this.newCategoryStageShow = false
			}
		},
		projectPlanningCategories(newValue){
			if(newValue){
				const stage = this.projectPlanningCategories[0]?.stages.find(stage => stage.code && stage.code.includes('seremi'))
				this.hasSeremi = !!stage
				const stage_cmn = this.projectPlanningCategories[0]?.stages.find(stage => stage.code && stage.code.includes('cmn'))
				this.hasCMN = !!stage_cmn
			}
		},
		companyProjects(newValue){
			if(newValue && this.selectedProject){
				this.setStartingSelected()
			}
		}
	},
	mounted(){
		this.selectedProject = this.$store.state.projects.projectPlanningConfigModal?.project
		if(this.selectedProject){
			this.debouncedGetProjectPlanning(true)
			this.getCategories()
		}
		this.reloadInfo()
		this.showValidationMessage = _throttle((messageData) => {
			this.setMessage(messageData)
		}, 3000, { leading: true, trailing: false })
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
  methods: {
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		reloadInfo(){
			this.getCompanyProjects()
			this.getZonesIpt()
			this.getAdditionalStages()
		},
		toProjectTypes(){
			this.$store.commit('projects/setProjectPlanningConfigModal', null)
			this.$router.push({ name: 'ProjectTypes' })
		},
		closeNoReceptionInTableModal(add_reception = false){
			this.showNoreceptionModal = false
			if(add_reception){
				eventBus.$emit('addReceptionToProjectCost', this.selectedProject.id)
			}
			this.$store.commit('projects/setProjectPlanningConfigModal', null)
		},
		setStartingSelected(){
			const project = this.companyProjects.find((project) => {
				return project.id == this.selectedProject.id
			})
			if(project){
				this.selectedProject = project
			}
		},
		async getAdditionalStages(){
			this.loadingAdditionalStages = true
			const data = {}
			const stages = await getAllProjectPlanningStages(data)
			if(stages.code == 200){
				this.additionalStages = stages.project_planning_stages
			}
			this.loadingAdditionalStages = false
		},
		startNewAdditionalStage(){
			this.$store.commit('projects/setAdditionalStageModal', true)
		},
		startEditAdditionalStage(stage){
			const data = {
				...stage,
				...{project_planning_stage_id: stage.id}
			}
			this.$store.commit('projects/setAdditionalStageModalEdit', data)
			this.$store.commit('projects/setAdditionalStageModal', true)
		},
		goToPreProject(){
			if(this.selectedProject){
				this.$store.commit('users/setClientModalInfo', {id: this.selectedProject.client_id})
				this.$store.commit('users/setClientModal', true)
				// this.$router.push({
				// 	name: 'Client',
				// 	params: { id: this.selectedProject.client_id },
				// 	query: { p: this.selectedProject.info?.preproject?.preproject_id }
				// })
			}
		},
		projectLineAssociations(item){
			if(item.associations){
				const project_associations = item.associations?.associations
				return project_associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				// this.$router.push({ name: 'PreProject', params: { id: association.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				// this.$router.push({ name: 'Conversation', params: { id: association.morphable_id } })
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
		async getProjectPlanning(showLoading = false){
			if(showLoading){this.loading = true}
			const planning = await getProjectPlanningPrj({project_id: this.selectedProject.id})
			if(planning.code == 200){
				this.projectPlanning = planning.project_planning
				this.projectCost = planning.project_cost
			}
			this.loading = false
		},
		debouncedGetProjectPlanning: _debounce(async function(showLoading = false) {
			await this.getProjectPlanning(showLoading);
		}, 500),
		startCategoryToProject(category){
			this.projectPlanning = {...this.projectPlanning, ...{planning_categories: [category]}}
		},
		async setCategoryToProject(category){
			if(!this.selectedProject){
				const messageData = {
					message: 'Por favor selecciona un proyecto para comenzar',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
				return
			}
			const data = {
				company_stage_id: category.id,
				project_id: this.selectedProject.id
			}
			const planning = await setProjectPlanningCategoryPrj(data)
			if(planning.code === 200){
				// this.projectPlanning = planning.project_planning
				if(!this.projectCostWithReception && category.with_reception){
					this.showNoreceptionModal = true
				}
				this.debouncedGetProjectPlanning()
				eventBus.$emit('reloadInformation')
			}
		},
		hasAdditionalStage(stage_to_check){
			if(this.projectPlanningCategories[0]){
				const stage_included = this.projectPlanningCategories[0].stages.find(stage => stage.code && stage.code.includes('ad_' + stage_to_check.id))
				return !!stage_included
			}
			return false
		},
		async toggleAdditionalStage(stage, status){
			if(status){
				const stageCode = 'ad_' + stage.id;
				const data = {
					name: stage.name,
					code: stageCode,
					description: stage.description,
					order: this.projectPlanningCategories[0].stages.length + 1,
					needs_payment: stage.needs_payment,
					project_planning_cat_id: this.projectPlanningCategories[0].id,
					company_project_planning_stage_id: stage.id
				}
				
				const tempStageId = 'temp_' + Date.now();
				const tempStage = { ...data, id: tempStageId };
				this.projectPlanningCategories[0].stages.push(tempStage);
				
				const creationPromise = (async () => {
					try {
						const category = await createProjectPlanningStagePrj(data)
						if(category.code == 200){
							const index = this.projectPlanningCategories[0].stages.findIndex(s => s.id === tempStageId);
							if (index !== -1) {
								this.projectPlanningCategories[0].stages[index] = category.project_planning_stage;
							}
							this.closeNewCategoryStage()
							eventBus.$emit('reloadInformation')
							return category.project_planning_stage;
						} else {
							const index = this.projectPlanningCategories[0].stages.findIndex(s => s.id === tempStageId);
							if (index !== -1) {
								this.projectPlanningCategories[0].stages.splice(index, 1);
							}
							throw new Error('Failed to create stage');
						}
					} catch (error) {
						const index = this.projectPlanningCategories[0].stages.findIndex(s => s.id === tempStageId);
						if (index !== -1) {
							this.projectPlanningCategories[0].stages.splice(index, 1);
						}
						throw error;
					}
				})();
				this.stageCreationPromises.set(stageCode, creationPromise);
			}
			else{
				const stageCode = 'ad_' + stage.id;
				
				// Esperar a que se complete la creación si aún está en progreso
				const creationPromise = this.stageCreationPromises.get(stageCode);
				if (creationPromise) {
					creationPromise.then(async () => {
						// Una vez que se completa la creación, ejecutar la eliminación
						const stage_r = this.projectPlanningCategories[0].stages.find(stage_check => stage_check.code === stageCode)
						if (stage_r) {
							const index = this.projectPlanningCategories[0].stages.findIndex(s => s.id === stage_r.id);
							if (index !== -1) {
								this.projectPlanningCategories[0].stages.splice(index, 1);
							}
							try {
								await this.deleteStage(stage_r.id);
							} catch (error) {
								this.projectPlanningCategories[0].stages.splice(index, 0, stage_r);
							}
						}
						this.stageCreationPromises.delete(stageCode);
					}).catch(() => {
						// Si la creación falla, no hacer nada
						this.stageCreationPromises.delete(stageCode);
					});
				} else {
					// Si no hay promesa en progreso, eliminar inmediatamente
					const stage_r = this.projectPlanningCategories[0].stages.find(stage_check => stage_check.code === stageCode)
					if (stage_r) {
						const index = this.projectPlanningCategories[0].stages.findIndex(s => s.id === stage_r.id);
						if (index !== -1) {
							this.projectPlanningCategories[0].stages.splice(index, 1);
						}
						try {
							await this.deleteStage(stage_r.id);
						} catch (error) {
							this.projectPlanningCategories[0].stages.splice(index, 0, stage_r);
						}
					}
				}
			}
		},
		toNewCopiedStage(info){
			this.selectedZone = info.zone_id
			this.projectType = info.project_type_id

			this.getCategories()
			this.selectedCategory = info.project_planning_category_id
		},
		copyCategoriesConfig(to_copy_category_id){
			this.$store.commit('projects/setToCopyCompanyPlanningCategoryId', to_copy_category_id)
		},
		getCategories(){
			if(this.selectedZone){
				this.$store.dispatch('projects/getAllProjectPlanningCategories', {
					zone_id: this.selectedProject.zone_id,
					project_type_id: this.selectedProject.project_type_id
				})
			}
		},
		getCompanyProjects(){
			this.$store.dispatch('projects/getProjects')
		},
		getZonesIpt(){
			this.$store.dispatch('projects/getAllZoneIpts')
		},
		startNewProject(){
			this.$store.commit('projects/setProjectModalInfo', null)
			this.$store.commit('projects/setProjectModal', true)
		},
		startEditZoneIpt(zone){
			const data = {
				...zone,
				...{zone_ipt_id: zone.id}
			}
			this.$store.commit('projects/setZoneIptModalEditInfo', data)
			this.$store.commit('projects/setZoneIptModal', true)
		},
		startNewZoneIpt(){
			this.$store.commit('projects/setZoneIptModalEditInfo', null)
			this.$store.commit('projects/setZoneIptModal', true)
		},
		async deleteZoneIpt(zone_id){
			const stage = await deleteZoneIpt({zone_ipt_id: zone_id})
			if(stage.code == 200){
				this.getZonesIpt()
			}
		},
		compareCategories(planningCategories, category) {
			return planningCategories.some(planningCat => 
					category.some(cat => 
							planningCat.name.includes(cat.name) || cat.name.includes(planningCat.name)
					)
			);
		},
		async handleSelectedCategory(category) {
			if(this.compareCategories(this.projectPlanning.planning_categories, category)){
				const messageData = {
					message: 'Ya existe una estapa de este tipo en la configuración',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
			else{
				// this.projectPlanning = {...this.projectPlanning, ...{planning_categories: category}}
				this.setCategoryToProject(category)
			}
		},
		startEditStage(stage){
			this.editCategoryStage = stage
			this.editStage = true
		},
		cancelEditStage(){
			this.editStage = false
			this.editCategoryStage = null
		},
		startEditCategory(category){
			const general_stage = !category.project_type_id
			const data = {
				...category,
				...{project_planning_category_id: category.id},
				...{zone_id: this.selectedZone, project_type_id: this.projectType, general_stage}
			}
			this.$store.commit('projects/setCategoryModalEditInfo', data)
			this.$store.commit('projects/setCategoryModal', true)
		},
		cancelEditCategory(){
			this.$store.commit('projects/setCategoryModal', false)
			this.$store.commit('projects/setCategoryModalEditInfo', null)
		},
		async updateStage(){
			this.loadingCreateCategory = true
			
			// Validar que el nombre no esté vacío
			if (!this.editCategoryStage.name || this.editCategoryStage.name.trim() === '') {
				const messageData = {
					message: 'El nombre de la etapa es requerido',
					title: 'Campo requerido',
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#FFA500',
				}
				this.showValidationMessage(messageData)
				this.loadingCreateCategory = false
				return
			}
			
			const data = {
				...this.editCategoryStage,
				...{project_planning_stage_id: this.editCategoryStage.id}
			}
			const stage = await updateProjectPlanningStagePrj(data)
			if(stage.code == 200){
				this.debouncedGetProjectPlanning()
				this.cancelEditStage()
				eventBus.$emit('reloadInformation')
			}
			this.loadingCreateCategory = false
		},
		startNewCategory(){
			const data = {
				zone_id: this.selectedZone,
				order: this.categories.length + 1,
				project_type_id: this.projectType
			}
			this.$store.commit('projects/setCategoryModalEditInfo', data)
			this.$store.commit('projects/setCategoryModal', true)
		},
		closeNewCategory(){
			this.newCategory = {
				name: null,
				description: null,
				order: 1
			}
			this.newCategoryShow = false
		},
		startNewCategoryStage(category){
			this.newCategoryStage = {
				name: null,
				description: null,
				order: category.stages.length + 1,
				needs_payment: false,
				project_planning_cat_id: category.id
			}
			this.newCategoryStageShow = true
		},
		closeNewCategoryStage(){
			this.newCategoryStage = {
				name: null,
				description: null,
				order: 1,
				needs_payment: false,
				project_planning_cat_id: null
			}
			this.newCategoryStageShow = false
		},
		async confirmCategoryStage(){
			this.loadingCreateCategory = true
			
			// Validar que el nombre no esté vacío
			if (!this.newCategoryStage.name || this.newCategoryStage.name.trim() === '') {
				const messageData = {
					message: 'El nombre de la etapa es requerido',
					title: 'Campo requerido',
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#FFA500',
				}
				this.showValidationMessage(messageData)
				this.loadingCreateCategory = false
				return
			}
			
			const category = await createProjectPlanningStagePrj(this.newCategoryStage)
			if(category.code == 200){
				this.closeNewCategoryStage()
				this.debouncedGetProjectPlanning()
				eventBus.$emit('reloadInformation')
			}
			this.loadingCreateCategory = false
		},
		async confirmCategory(){
			this.loadingCreateCategory = true
			const category = await createProjectPlanningCategory(this.newCategory)
			if(category.code == 200){
				this.closeNewCategory()
				this.getCategories()
				eventBus.$emit('reloadInformation')
			}
			this.loadingCreateCategory = false
		},
		async deleteStage(stage_id){
			const stage = await removeProjectPlanningStage({project_planning_stage_id: stage_id})
			if(stage.code == 200){
				this.debouncedGetProjectPlanning()
				eventBus.$emit('reloadInformation')
			}
		},
		async deleteCategory(category_id){
			const category = await deleteProjectPlanningCategory({project_planning_category_id: category_id})
			if(category.code == 200){
				this.getCategories()
			}
		},
		selectZone(zone){
			this.selectedZone = zone
		},
		onMoveDragEvent(evt){
			return evt.related.className.indexOf('exclude') === -1
		},
		startEndDragEventStages: _debounce(function(ev, planning){ this.endDragEventStages(ev, planning) }, 500),
		async endDragEventStages(ev, planning){
			if (typeof ev.newIndex === 'number') {
				this.loadingStateOrder = true
				const stages = planning.stages.map((stage, index) => {
					return {
						id: stage.id,
						order: index + 1
					}
				})
				const data = {
					project_id: this.selectedProject.id,
					stages
				}
				const stages_r = await updateProjectPlanningStageOrderPrj(data)
				if(stages_r.code == 200){
					// this.projectPlanning = stages_r.project_planning
					this.debouncedGetProjectPlanning()
				}
				this.loadingStateOrder = false
				eventBus.$emit('reloadInformation')
				// const promises = planning.stages.map((stage, index) => {
				// 	const data = {
				// 		project_planning_stage_id: stage.id,
				// 		order: index + 1
				// 	}
				// 	return updateProjectPlanningStagePrj(data);
				// });

				// Promise.all(promises)
				// 	.then(() => {
				// 		this.getProjectPlanning()
				// 		this.loadingStateOrder = false
				// 	})
				// 	.catch(() => {
				// 		this.loadingStateOrder = false
				// 	})
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		async changeIptZone(zone_id){
			this.zoneMenu = false
			const data = {
				project_id: this.selectedProject.id,
				zone_id
			}
			const project_info = await updateProjectInfo(data)
			if(project_info.code == 200){
				this.getCompanyProjects()
			}
		},
		async changeProjectType(project_type_id){
			this.projectTypeMenu = false
			const data = {
				project_id: this.selectedProject.id,
				project_type_id
			}
			const project_info = await updateProjectInfo(data)
			if(project_info.code == 200){
				this.getCompanyProjects()
			}
		},
  },
};
</script>

<style scoped>
.square-card{
	aspect-ratio: 1;
	cursor: move;
	overflow: hidden;
}
.custom-height-calendar .v-input__control,
.custom-height-calendar .v-field__input,
.custom-height-calendar .v-input__slot,
.custom-height-calendar .v-select__slot {
  height: 30px!important;
	min-height: 30px!important;
}
.custom-height-calendar .v-input__append-inner{
	margin-top: 3px!important;
}
.custom-calendar-sidemini .v-date-picker-table{
	height: auto;
}
.custom-height-search label{
	font-size: 12px;
	top: 5px!important;
}
/* .custom-height-search .v-progress-linear .v-progress-linear__background {
  background-color: #FF120B;
  color: #FF120B;
} */
.custom-height-search .v-progress-linear__indeterminate {
  background-color: #FF120B!important; /* Cambia este color */
}
.ghost-element-drag{
	opacity: 0;
}
.item-background-hover:hover{
	background-color: rgba(0,0,0,0.1);
}
.action-container{
	width: 50px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.light-blue-text{color: #959595;}
.stage-container-list-item{
	border: 1px solid #cacaca;
	border-radius: 10px;
}
.blocked-content-cost-table {
	pointer-events: none;
	opacity: 0.6;
}
.custom-blocked-additional-stages {
	pointer-events: none;
	opacity: 1;
	background-color: rgba(255, 255, 255, 0.8);
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	bottom: 0;
	right:0;
	left: 0;
	z-index: 9;
}
</style>